import React, { createContext, useContext, useState, useCallback } from 'react';
import { trackLanguageChanged } from '../utils/analytics';
import en from './en.json';
import fr from './fr.json';
import es from './es.json';
import he from './he.json';

const translations = { en, fr, es, he };

export const languages = [
  { code: 'en', label: 'EN', name: 'English' },
  { code: 'fr', label: 'FR', name: 'Français' },
  { code: 'es', label: 'ES', name: 'Español' },
  { code: 'he', label: 'עב', name: 'עברית' },
];
const I18nContext = createContext();

function detectLanguage() {
  const saved = localStorage.getItem('game99_lang');
  if (saved && translations[saved]) return saved;
  const browser = navigator.language?.slice(0, 2);
  return translations[browser] ? browser : 'en';
}

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(detectLanguage);

  const setLang = useCallback((l) => {
    if (translations[l]) {
      setLangState(l);
      localStorage.setItem('game99_lang', l);
      trackLanguageChanged(l);
    }
  }, []);

  const t = useCallback((key) => {
    return translations[lang]?.[key] || translations.en[key] || key;
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useTranslation() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useTranslation must be used within I18nProvider');
  return ctx;
}
